<template>
  <div class="practice-exercises-root">
    <p class="exercise-title">{{ exerciseTitle }}</p>
    <div class="exercise-main" v-if="startRender">
      <Choice
        v-if="exerciseKey == 'Choice'"
        :questionKey="questionKey"
        :answerKey="answerKey"
        :currentItem="currentItem"
        @choiceGetAnswer="choiceGetAnswer"
      ></Choice>
      <Judge
        v-else-if="exerciseKey == 'Judge'"
        :questionKey="questionKey"
        :answerKey="answerKey"
        :currentItem="currentItem"
        @judgeGetAnswer="choiceGetAnswer"
      ></Judge>
      <Pairs
        v-else-if="exerciseKey == 'Pairs'"
        :questionKey="questionKey"
        :answerKey="answerKey"
        :currentItem="currentItem"
        :pairsUserAnswer="pairsUserAnswer"
        :pairsCheckedAnswer="pairsCheckedAnswer"
        @emitUserAnswer="emitUserAnswer"
      ></Pairs>
    </div>
    <div class="exercise-button-con">
      <div class="circle-btn-con" v-if="exerciseKey == 'Pairs' && pairsCheckedAnswer">
        <span class="button-text">{{
          pairsUserAnswer
            ? $t('free_practice_show_correct_answers')
            : $t('free_practice_show_my_answers')
        }}</span>
        <div class="fp-button circle-btn green-circle-btn" @click="switchPairsAnswerType">
          <img src="@/assets/images/free-practice/pair_switch.png" class="inside-icon" />
        </div>
      </div>
      <div
        class="circle-btn-con"
        v-if="
          exerciseKey == 'Choice' ||
          exerciseKey == 'Judge' ||
          (exerciseKey == 'Pairs' && pairsCheckedAnswer)
        "
      >
        <span class="button-text">{{ $t('user_apply_delete_account_next_title') }}</span>
        <div
          class="fp-button circle-btn yellow-circle-btn"
          :disabled="disabledNext"
          @click="nextPage"
        >
          <img src="@/assets/images/free-practice/arrow_forward.png" class="inside-icon" />
        </div>
      </div>
      <div class="circle-btn-con" v-else-if="exerciseKey == 'Pairs' && !pairsCheckedAnswer">
        <span class="button-text">{{ $t('free_practice_check') }}</span>
        <div
          class="fp-button circle-btn yellow-circle-btn"
          :disabled="disabledCheck"
          @click="checkPairsAnswer"
        >
          <img src="@/assets/images/free-practice/arrow_forward.png" class="inside-icon" />
        </div>
      </div>
    </div>
    <!-- 左下方页码 -->
    <CardPaganation
      class="exercise-paganation"
      :currentPage="currentPage"
      :totalPage="totalPage"
    ></CardPaganation>
  </div>
</template>
<script>
import CardPaganation from './common/cardPaganation'
import Choice from './common/choice'
import Judge from './common/judge'
import Pairs from './common/pairs'
import { getSelectOptions } from '@/serves/api/freePractice'
import { deepClone } from '@/utils/utils'
import _ from 'lodash'
export default {
  props: {
    questionKey: {
      type: String,
      default: 'Meaning',
    },
    answerKey: {
      type: String,
      default: 'Sound',
    },
    exerciseKey: {
      type: String,
      default: 'Choice',
    },
    renderList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      totalPage: 1,
      currentPage: 1,
      getFirstOption: '',
      startRender: false,
      disabledNext: true,
      disabledCheck: true,
      pairsUserAnswer: true, //展示用户答案或正确答案
      pairsCheckedAnswer: false, // 连线题是否已经点击check按钮
      pairsRenderList: [],
    }
  },
  computed: {
    exerciseTitle() {
      const judgeTitle = {
        Meaning: this.$t('free_practice_exercise_meaning_title'),
        Sound: this.$t('free_practice_exercise_sound_title'),
        Characters: this.$t('free_practice_exercise_characters_title'),
        Pinyin: this.$t('free_practice_exercise_sound_title'),
      }
      switch (this.exerciseKey) {
        case 'Choice':
          return this.$t('free_practice_exercise_select_title')
        case 'Judge':
          return judgeTitle[this.answerKey]
        case 'Pairs':
          return this.$t('free_practice_exercise_pairs_title')
        default:
          return ''
      }
    },
    currentItem() {
      if (this.exerciseKey == 'Pairs') {
        return this.pairsRenderList[this.currentPage - 1]
      }
      return this.renderList[this.currentPage - 1]
    },
  },
  methods: {
    switchPairsAnswerType() {
      // 展示用户答案||正确答案
      this.pairsUserAnswer = !this.pairsUserAnswer
    },
    checkPairsAnswer() {
      this.disabledNext = false // 允许跳过
      this.pairsCheckedAnswer = true // 允许展示switch答案按钮
    },
    // shuffleArr(arr) {
    //   arr.sort((a, b) => Math.random() - 0.5)
    //   return arr
    // },
    handleRenderList() {
      this.renderList.forEach((item, index) => {
        let params = {
          character: item.characters,
          pinyin: item.pinyin,
        }
        getSelectOptions(params).then((res) => {
          if (res.errcode == 0) {
            let resData = res.data
            if (this.exerciseKey == 'Judge') {
              resData = [res.data[Math.floor(Math.random() * 3)]]
            }
            const originOptions = resData
              .map((option, optionIndex) => {
                return {
                  ...option,
                  type: this.answerKey,
                  content: this.exerciseKey == 'Judge' ? '×' : '',
                  correct: false,
                  id: optionIndex + 1,
                }
              })
              .concat({
                ...item,
                type: this.answerKey,
                content: this.exerciseKey == 'Judge' ? '√' : '',
                correct: true,
              })

            item = Object.assign(item, {
              question_type: this.questionKey,
              answer_type: this.answerKey,
              exercise_type: this.exerciseKey,
              title: this.exerciseTitle,
              describe: '',
              choose: [],
              option: _.shuffle(originOptions).map((o, i) => {
                return { ...o, index: i + 1 + '' }
              }),
              user_answer: [],
              right_answer: [],
              user_answer_status: '0',
            })

            if (index == 0) {
              // 第一个资源返回，即可以开始答题
              this.startRender = true
            }
          }
        })
      })
    },
    choiceGetAnswer(obj) {
      this.currentItem.user_answer = [obj.id + '']
      this.currentItem.user_answer_status = obj.correct ? '1' : '2'
      if (obj.correct) {
        // 正确调到下一题
        setTimeout(() => {
          this.disabledNext = false
          this.nextPage()
        }, 1000)
      } else {
        this.disabledNext = false
      }
    },
    emitUserAnswer(userAnswer) {
      if (userAnswer.length == this.currentItem.choose.length) {
        // 允许检查答案，并将数据存入renderList
        this.disabledCheck = false
        let cloneAnswer = Object.values(deepClone(userAnswer))
        this.currentItem.user_answer = cloneAnswer
          .sort((a, b) => {
            return a.lineArr[0] - b.lineArr[0]
          })
          .map((item) => {
            return item.lineArr[0] + '-' + item.lineArr[1]
          })
      } else {
        this.disabledCheck = true
      }
    },
    nextPage() {
      if (this.disabledNext) return
      if (this.currentPage == this.totalPage) {
        this.submitAnswer()
      } else {
        this.currentPage++
        this.disabledNext = true
        this.disabledCheck = true
        this.pairsUserAnswer = true
        this.pairsCheckedAnswer = false
      }
    },
    submitAnswer() {
      console.log('submitanswer')
      let answerRate = '0%'
      let correctCount = 0
      let subParams = {}
      if (this.exerciseKey == 'Choice' || this.exerciseKey == 'Judge') {
        correctCount = this.renderList.reduce((prev, current) => {
          if (current.user_answer_status == '1') {
            return prev + 1
          } else {
            return prev
          }
        }, 0)
        answerRate = (Number(((correctCount * 100) / this.renderList.length).toFixed(0)) || 0) + '%'
        this.renderList.forEach((item) => {
          if (item.user_answer?.length) {
            item.user_answer = item.user_answer.map(String)
          }
        })
        subParams = {
          answer_list: [...this.renderList],
          answer_rate: answerRate,
          section_type: 'practice',
          section_name: 'words',
          correctCount: correctCount,
        }
        this.$emit('savePracticeRes', subParams)
      } else if (this.exerciseKey == 'Pairs') {
        let totalCount = 0
        let correctCount = 0
        this.pairsRenderList.forEach((list) => {
          let tempTotal = list.user_answer.length
          let tempCorrect = 0
          for (let i = 0; i < list.user_answer.length; i++) {
            if (list.user_answer[i] == list.right_answer[i]) {
              tempCorrect++
            }
          }
          if (tempTotal == tempCorrect) {
            list.user_answer_status = '1'
          } else {
            list.user_answer_status = '2'
          }
          totalCount = totalCount + tempTotal
          correctCount = correctCount + tempCorrect
        })
        answerRate = (Number(((correctCount * 100) / totalCount).toFixed(0)) || 0) + '%'
        subParams = {
          answer_list: [...this.pairsRenderList],
          answer_rate: answerRate,
          section_type: 'practice',
          section_name: 'words',
          correctCount: correctCount,
        }

        this.$emit('savePracticeRes', subParams, 'Pairs')
      }
    },
    devidePairsPages(data) {
      // 根据选中词数量划分每页连线数量
      let num = data.length
      if (num < 3) return
      const Quotient = parseInt(num / 8)
      const remainder = num % 8
      if (remainder == 0) {
        const list = new Array(Quotient).fill('')
        return list.map(() => 8)
      } else {
        const list = new Array(Quotient + 1).fill('')
        const a = parseInt(num / (Quotient + 1))
        const b = num % (Quotient + 1)
        if (b == 0) {
          return list.map(() => a)
        } else {
          return list.map((item, index) => {
            if (index < b) {
              return a + 1
            } else {
              return a
            }
          })
        }
      }
    },
    getPairsChooseOrOPtion(data, type, questionType) {
      const _optionFlag = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H']
      let newData = Object.values(deepClone(data))
      newData?.map((item, index) => {
        Object.assign(item, {
          index: type == 'choose' ? index + 1 + '' : _optionFlag[index],
          type: questionType,
          content: '',
          correct: type == 'choose' ? true : false,
        })
      })
      //重置option的index
      if (type === 'option') {
        newData = _.shuffle(newData) //选项乱序
        newData?.map((item, index) => {
          item.index = _optionFlag[index]
        })
      }
      return newData
    },
    getRightAnswer(choose, option) {
      let rightData = []
      let optionIndex = ''
      choose?.map((item) => {
        optionIndex = option.filter((o) => o.id === item.id)[0]?.index || ''
        rightData.push(item.index + '-' + optionIndex)
      })
      return rightData
    },
    handleResourceToPairs(originalWordsData) {
      // 清空待渲染列表 == answer_list
      this.pairsRenderList = []
      // 得到题目页数&&每页题目数 -- [5,5]
      let totalPageList = this.devidePairsPages(originalWordsData)
      this.totalPage = totalPageList.length

      let cloneRender = Object.values(deepClone(this.renderList))
      totalPageList.forEach((item, index) => {
        let currentPageList = cloneRender.splice(0, item)
        let choose = this.getPairsChooseOrOPtion(currentPageList, 'choose', this.questionKey)
        let option = this.getPairsChooseOrOPtion(currentPageList, 'option', this.answerKey)
        let rightAnswer = this.getRightAnswer(choose, option)
        this.pairsRenderList.push({
          characters: '',
          illustration_url: '',
          pinyin: '',
          translation: '',
          tts_url: '',
          zht: '',
          question_type: this.questionKey,
          answer_type: this.answerKey,
          exercise_type: this.exerciseKey,
          title: this.exerciseTitle,
          describe: '',
          choose: choose,
          option: option,
          user_answer: [],
          right_answer: rightAnswer,
          user_answer_status: '0',
          id: index + 1,
        })
      })
      this.startRender = true
    },
  },
  mounted() {
    if (this.exerciseKey == 'Pairs') {
      this.handleResourceToPairs(this.renderList)
      this.totalPage = this.pairsRenderList.length
    } else {
      this.handleRenderList()
      this.totalPage = this.renderList.length
    }
  },
  components: {
    CardPaganation,
    Choice,
    Judge,
    Pairs,
  },
}
</script>
<style lang="scss" scoped>
@import './styles/testCreation.scss';
.practice-exercises-root {
  padding: 22px 0 0;
  position: relative;
  .exercise-title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 600;
    color: rgba(44, 47, 70, 1);
  }
  .exercise-main {
    width: 660px;
    margin: auto;
  }
  .exercise-button-con {
    display: flex;
    justify-content: center;
    margin: 50px auto 18px;
    .circle-btn-con {
      position: relative;
      display: flex;
      justify-content: center;
      width: 147px;
      .button-text {
        font-weight: 600;
        position: absolute;
        top: -22px;
        left: 50%;
        transform: translateX(-50%);
        color: #515571;
        font-size: 12px;
        word-break: keep-all;
        white-space: nowrap;
      }
    }
    .circle-btn {
      border-radius: 50%;
      width: 64px;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      .inside-icon {
        width: 26px;
        height: 25.5px;
      }
    }
    .yellow-circle-btn {
      background: #faae56;
    }
    .green-circle-btn {
      background: #39b38e;
      .inside-icon {
        width: 40px;
        height: 40px;
      }
    }
  }
  .exercise-paganation {
    position: absolute;
    bottom: -18px;
    left: 0;
  }
}
</style>
